import { render } from "./AnswerComponent.vue?vue&type=template&id=597ca048&scoped=true"
import script from "./AnswerComponent.vue?vue&type=script&lang=js"
export * from "./AnswerComponent.vue?vue&type=script&lang=js"

import "./AnswerComponent.vue?vue&type=style&index=0&id=597ca048&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597ca048"]])

export default __exports__